import I18n from 'i18n-js';
import Store from '../configureStore';
import ar from './FixedExpressions/ar.json'; // Arabic
import en from './FixedExpressions/en.json'; // English
import es from './FixedExpressions/es.json'; // Spanish
import fa from './FixedExpressions/fa.json'; // Persian
import fl from './FixedExpressions/fl.json'; // Filipino
import fr from './FixedExpressions/fr.json'; // French
import gr from './FixedExpressions/gr.json'; // Greek
import hi from './FixedExpressions/hi.json'; // Hindi
import ht from './FixedExpressions/ht.json'; // Haitian
import it from './FixedExpressions/it.json'; // Italian
import kh from './FixedExpressions/kh.json'; // Khmer
import ko from './FixedExpressions/ko.json'; // Korean
import pt from './FixedExpressions/pt.json'; // Portuguese
import pu from './FixedExpressions/pu.json'; // Punjabi
import ru from './FixedExpressions/ru.json'; // Russian
import so from './FixedExpressions/so.json'; // Somali
import ur from './FixedExpressions/ur.json'; // Urdu
import vi from './FixedExpressions/vi.json'; // Vietnam
import zh_Hans from './FixedExpressions/zh-Hans.json'; // Simple Chinese
import zh_Hant from './FixedExpressions/zh-Hant.json'; // traditional Chinese
import arm from './FixedExpressions/arm.json';
import pl from './FixedExpressions/pl.json';
import ukr from './FixedExpressions/ukr.json';
import de from './FixedExpressions/de.json';

const { store } = Store;
const onBeforeLift = () => {
  let langKey = store.getState().config.selectedLang;
  if (
    langKey
    && langKey.substr(0, 2) === 'en'
  ) langKey = 'en_AU';
  return (langKey);
};

/**
 * I18: a tool for translate the characters
 * By providing the fixed expressions it can read the translated items key by key
 *
 * @author Alireza Zebardast & Mahziar Eghdami
 * @param {Object} params
 * @param {String} name
 *
 */
export function _(name, params = {}) {
  const { defaultLang } = store.getState().config;
  window.I18n = {};
  I18n.translations = {
    en,
    en_AU: en,
    'en-CA': en,
    en_US: en,
    en_CA: en,
    es_US: es,
    en_BR: en,
    en_NZ: en,
    hd_IN: hi,
    kr_KR: ko,
    pt_PT: pt,
    PN_PN: pu,
    FL_FL: fl,
    ar_SA: ar,
    so_SO: so,
    ur_UR: ur,
    ht_HT: ht,
    vi_VI: vi,
    it_IT: it,
    gr_GR: gr,
    fr_CA: fr,
    RU_RU: ru,
    KH_KH: kh,
    fa_IR: fa,
    sp_CH: zh_Hans,
    tr_CH: zh_Hant,
    am_AR: arm,
    pl_PL: pl,
    uk_UA: ukr,
    de_DE: de
  };
  I18n.defaultLocale = defaultLang || 'en_AU';
  I18n.locale = onBeforeLift();
  I18n.fallbacks = true;
  return I18n.t(name, params);
}

export default I18n;
export { onBeforeLift };
